module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAYCAYAAAAVibZIAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADZSURBVHgB7ZXvEYIwDMVTdQBG0AkcQUdgAxhBN+gmsol1AkZwBN0AE0nP0quS/vEb7+5BW8KPx116BRil0QNMNfA6RNS8tebFA3qLVuijY9KOx3M1xkJV4OupUu4k+AsR0uAFW8EftEDLawP5MuD0KKlEUsN3jW5pUCJpg+6c+Z4uOc3f8Ps9umL4IwfqA8l3dhI0BOx5rU6B/gK2tigGKgLGQMVAKTQKKIHWsUAJ9AJjm4iBEigBr5xYBLRnlEHfvGedA7V6os8w3ZZfk4ZccTpKeYLPyTmrF/TNWaXvrbcqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/edit.png
// module id = J5XX
// module chunks = 36